<template>
  <div>
    <el-upload :class="['file-upload', { readonly }]" :disabled="readonly" :data="fileData" :multiple="multiple"
      :file-list="formatFileList" :accept="accept" :action="$apis.common.uploadQiniup" :limit="limit"
      :before-upload="beforeUpload" :on-success="onSuccess" :on-exceed="onExceed" :on-remove="onRemove" v-bind="$attrs">
      <el-button type="text" icon="el-icon-plus" v-if="!readonly" size="small">点击上传</el-button>
      <template #file="{ file, index }">
        <div class="file-list-item" v-if="['uploading', 'success', 'ready'].includes(file.status)">
          <i class="el-icon-document"></i>
          <span class="name">{{ file.name }}</span>
          <i class="el-icon-delete close" v-if="file.status === 'success' && !readonly"
            @click="onRemove(file, index)"></i>
          <i class="el-icon-view download" v-if="file.status === 'success' && readonly && download"
            @click="onPreview(file)"></i>
          <i class="el-icon-download download" v-if="file.status === 'success' && readonly && download"
            @click="onDownload(file)"></i>
          <el-progress v-if="file.status === 'uploading'" :stroke-width="4" :percentage="file.percentage" />
        </div>
      </template>
      <template #tip>
        <div v-if="!readonly" class="el-upload__tip">支持{{ accept }}的文件，单个文件不超过 {{ maxSize }}MB，最多可上传 {{ limit }} 个文件
        </div>
        <div class="no-data" v-else-if="!formatFileList.length">
          <span>暂无附件</span>
        </div>
      </template>
    </el-upload>

    <el-dialog :title="previewInfo.title || ''" :append-to-body="true" :visible.sync="showPreview" width='1200px'
      class="dialog" :close-on-click-modal='false' destroy-on-close>
      <div v-loading="loadingDialog">
        <iframe :src="previewInfo.previewUrl" ref="iframe"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { picDns, videoDns, fileDns, bucket } from '@/components/uploadFile/config'
import { getUUID } from '@/utils/formatData'
import Base64 from '@/utils/base64.min.js'
export default {
  name: 'FileUpload',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    accept: {
      type: String,
      // ,.zip,.rar,.7z,.csv
      default: '.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx,.txt'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 10
    },
    maxSize: {
      type: Number,
      default: 50
    },
    download: {
      type: Boolean,
      default: true
    },
    preview: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileData: {
        token: '',
        key: ''
      },
      showPreview: false,
      loadingDialog: false,
      previewInfo: {}
    }
  },
  computed: {
    formatFileList() {
      return this.value.map(item => {
        return {
          name: item.fileName,
          url: item.filePrefix + item.fileUrl
        }
      })
    }
  },
  watch: {
  },
  created() {
    this.getToken()
  },
  methods: {
    // 空间名：testipark，对应的下载链接http://test.qxt.cdn.gintell.cn + '/' + key
    getToken() {
      this.$axios.get(this.$apis.common.uploadToken, { bucket }).then(res => {
        this.fileData.token = res
      })
    },
    // 获取key 年/月/日/uuid
    getKey() {
      const date = new Date()
      this.fileData.key = `${date.getFullYear()}${(date.getMonth() + 1)}${date.getDate()}/${getUUID()}`
    },
    // 文件访问域名(根据图片，视频，其他文件判断)
    fileDns(value) {
      const strImg = 'jpeg,jpg,png'
      const strVideo = 'mp4,rmvb,avi'
      const type = value.substring(value.lastIndexOf('.') + 1).toLowerCase()
      if (strImg.indexOf(type) !== -1) {
        return picDns
      } else if (strVideo.indexOf(type) !== -1) {
        return videoDns
      } else {
        return fileDns
      }
    },
    onRemove(file) {
      const index = this.value.findIndex(item => item.fileName === file.name)
      this.value.splice(index, 1)
    },
    onPreview(file) {
      this.loadingDialog = true
      this.showPreview = true
      this.previewInfo = {
        title: file.name,
        previewUrl: location.origin + `/preview/onlinePreview?url=${encodeURIComponent(Base64.encode(file.url + '?fullfilename=' + file.name))}`
      }
      this.$nextTick(() => {
        this.$refs.iframe.addEventListener('load', () => {
          this.loadingDialog = false
        })
      })
    },
    // 下载
    onDownload(file) {
      window.location.href = `${file.url}?attname=${file.name}`
    },
    onSuccess(res, file, uploadFiles) {
      if (res.key) {
        // 保证没有文件需要处理了在进行双向绑定，否则会造成文件列表紊乱
        if (uploadFiles.every(item => !['ready', 'uploading'].includes(item.status))) {
          uploadFiles.forEach(item => {
            if (item.response) {
              const resData = item.response
              this.value.push({
                fileName: file.name,
                filePrefix: this.fileDns(file.name),
                fileUrl: resData.key
              })
            }
          })
        }
      } else {
        const fileIndex = uploadFiles.findIndex(item => item.uid === file.uid)
        uploadFiles.splice(fileIndex, 1)
        this.$message({ type: 'error', message: '上传失败！！！' })
      }
    },
    onExceed(files) {
      this.$message({
        type: 'error',
        message: `本次选择${files.length}个，已超出最大上传个数，请重新选择`
      })
    },
    beforeUpload(file) {
      const fileType = this.getFileType(file.name)
      if (!this.accept.includes(fileType)) {
        this.$message({ type: 'error', message: `${file.name}文件格式错误` })
        return false
      }
      if (file.size > this.maxSize * 1024 * 1024) {
        this.$message({ type: 'error', message: `${file.name}超过文件的最大大小` })
        return false
      }
      this.getKey()
    },
    getFileType(name) {
      const suffix = name.substring(name.lastIndexOf('.') + 1)
      return suffix.toLowerCase()
    }
  }
}
</script>

<style scoped lang="scss">
.file-list-item {
  width: 360px;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 6px;
  background-color: #f3f3f3;
  cursor: default;
  border-radius: 4px;

  &:hover {
    background-color: #e8e8e8;
  }

  .name {
    font-size: 14px;
    flex: 1;
    margin-left: 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .el-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    top: initial;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    overflow: hidden;

    ::v-deep {
      .el-progress-bar__outer {
        border-radius: 0;
      }

      .el-progress-bar__inner {
        border-radius: 0;
      }
    }
  }

  .close {
    cursor: pointer;
  }

  .download {
    cursor: pointer;
    margin-left: 8px;
  }
}

.file-upload {
  width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  &.readonly {
    ::v-deep {
      .el-upload-list__item:first-child {
        margin: 0;
      }
    }
  }

  ::v-deep {
    .el-upload-list {
      width: 360px;
    }

    .el-upload {
      display: inline-flex;
    }
  }
}

.el-upload__tip {
  margin-top: 0;
}

.no-data {
  font-size: 14px;
}

iframe {
  width: 100%;
  height: 600px;
}
</style>
